import React, { Fragment, useState, useEffect, memo } from "react";
import { connect } from "react-redux";
import {
  CircularProgress,
  FormControlLabel,
  InputLabel,
  Checkbox,
  Box,
  Paper
} from "@material-ui/core";
import {
  cloneDeep,
  forEach,
  values,
  sortBy,
  map,
  filter,
  pull,
  includes,
  get
} from "lodash";
import LazyLoad from "react-lazyload";
import { createTreeHierarchy, createFlatHierarchy } from "hierarchy-js";
import { createSubscription } from "../../../../utils/db";
import produce from "immer";

const TreeSelect = props => {
  const [selected, setSelected] = useState(props.value || []);
  // console.log({ selected });
  // const [data, setData] = useState(props.data);
  const [items, setItems] = useState([]);
  // const [isFetching, setIsFetching] = useState(!Boolean(props.data));
  // const [loaded, setLoaded] = useState(false);

  const assignParentId = (item, currentId, index) => {
    if (!item.parentId && currentId) {
      item.parentId = currentId;
    }

    // if ((!item.id || !item.isParent) && currentId) {
    if (!item.id && currentId) {
      item.id = `${item.parentId}.children[${index}]`;
    }

    if (item.children) {
      item.children = map(item.children, (children, i) =>
        assignParentId(children, item.id, i)
      );
    }

    return item;
  };

  useEffect(() => {
    if (props.data) {
      let newItems = produce(props.data, draft => {
        forEach(draft, (doc, id) => {
          doc.id = id;
          // doc.isParent = true;
          assignParentId(doc);
        });
      });
      // let newItems = map(cloneDeep(props.data), (item, id) => {
      //   item.id = id;
      //   item.isParent = true;
      //   assignParentId(item);
      //   return item;
      // });

      newItems = createFlatHierarchy(values(newItems)) || [];
      // console.log({ newItems });

      // console.log(newItems);
      setItems(newItems);
    }
  }, [props.data]);

  useEffect(() => {
    setSelected(props.value);
  }, [props.value]);

  createSubscription(props.relation.ref);

  if (!items) {
    return <CircularProgress />;
  }

  const handleSelect = value => e => {
    let newValue = [...selected];
    const { checked } = e.target;

    const pullChildren = itemValue => {
      const subitems = filter(items, item => item.parentId === itemValue);

      if (subitems.length) {
        subitems.forEach(item => {
          pull(newValue, item.id);
          pullChildren(item.id);
        });
      }
    };

    if (checked) {
      if (!includes(newValue, value)) {
        newValue.push(value);
      }
    } else {
      pull(newValue, value);
      pullChildren(value);
    }

    setSelected(newValue);
    props.onChange(newValue);
  };

  const renderCheckboxes = (items, indent = 0) => {
    return map(sortBy(items, ["order"]), item =>
      // console.log(item.id) ||
      !item.parentId ||
      item.parentId === 0 ||
      selected.includes(item.id) ||
      selected.includes(item.parentId) ? (
        <Fragment key={item.id}>
          {/* <LazyLoad
            overflow
            offset={50}
            height={28}
            scrollContainer={`#tree-select-${props.keyPrefix}`
              .replace('[', '')
              .replace(']', '')}
          > */}
          <Box ml={indent} height={28}>
            <FormControlLabel
              control={
                <Checkbox
                  data-id={item.id}
                  color="primary"
                  style={{ padding: 3 }}
                  checked={selected.includes(item.id)}
                  onChange={handleSelect(item.id)}
                />
              }
              label={map(
                props.relation.fields,
                fieldName => item[fieldName]
              ).join(" ")}
            />
          </Box>
          {/* </LazyLoad> */}
          {item.children && renderCheckboxes(item.children, indent + 2)}
        </Fragment>
      ) : null
    );
  };
  // console.log({ items });
  return (
    <>
      <Box mb={1}>
        <InputLabel>{props.label}</InputLabel>
      </Box>
      <Paper>
        <Box
          maxHeight={160}
          overflow="auto"
          pl={2}
          pr={2}
          pt={0.5}
          pb={0.5}
          id={`tree-select-${props.keyPrefix}`
            .replace("[", "")
            .replace("]", "")}
        >
          {items.length
            ? renderCheckboxes(createTreeHierarchy(items))
            : "No items found..."}
        </Box>
      </Paper>
    </>
  );
};

export default connect(
  ({ dbState }, props) => ({ data: get(dbState, `${props.relation.ref}`) }),
  null
)(memo(TreeSelect, () => false)); //  (pp, np) => pp.data === np.data || pp.value === np.value));
